import React from 'react';

import BaseNumber from './BaseFields/BaseNumber';
import { withFormikFormControl } from '../FormikFormControl';

export const Percent = (props) => {

  console.log('PERCENT CONFIG', props)
  return <BaseNumber {...({...props, extraConfig: {suffix: "%", ...props.extraConfig} })} />;
};

export const PercentFormik = withFormikFormControl()(Percent);

export default PercentFormik;
